import posNotificationInstance from '../instance'

const getNotificationDevice = (deviceId, username) => {
	return posNotificationInstance.get(`devices?deviceId=${deviceId}&userName=${username}`)
}

export default getNotificationDevice
